import React, { useRef, useEffect } from "react";
import videoFile from "../../components/face.mp4";
import audioFile from "../../components/chex.m4a";

function ChexRemoval() {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  useEffect(() => {
      const playMedia = async () => {
        if (videoRef.current && audioRef.current) {
          try {
            await videoRef.current.play();
            await audioRef.current.play();
          } catch (error) {
            console.log("Autoplay blocked by browser, user interaction needed.");
          }
        }
      };
      playMedia();
    }, []);

  return (
    <div className="container">
      <div className="banner" onClick={handlePlay}>
        <video
          ref={videoRef}
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
          className="video"
        />
      </div>

      <audio ref={audioRef} src={audioFile} />

      <div className="container_body">
        <div className="course">
          <h1>How to Get Removed From Chex System</h1>
          <p>
            Break Free from ChexSystems! 🚫💳 Join Regine Mazile as she shares
            expert insights on removing yourself from ChexSystems and getting
            back into the banking system. Learn the steps, legal strategies, and
            tips to rebuild your financial foundation and open up new
            opportunities. Let’s clear the path to financial freedom! 💼✨
            #ChexSystems
          </p>
          <p>EQUIFAX INQUIRY REMOVAL SCRIPT</p>
          <a href="https://docs.google.com/document/d/16igKhAWc_6MxYLPWjyHXUEajaw2Xv_McVHBu2eaai_4/edit?tab=t.0">
            https://docs.google.com/document/d/16igKhAWc_6MxYLPWjyHXUEajaw2Xv_McVHBu2eaai_4/edit?tab=t.0
          </a>
        </div>
      </div>
    </div>
  );
}

export default ChexRemoval;
